import supportedABTestPermissions from 'readingiq-src/js/config/supported-dynamic-permissions';
import stringUtils from 'readingiq-src/js/string-utils/1.0.0/index';
// AB Test Components gets mapped to User Permissions
// We validate if we support the AB Permission provided by the API
// Then We remove the existing permission that the AB Test it

const getPermissionsOverride = (componentsOverride = {}) => {
  return (
    Object.keys(componentsOverride)
      // .map(stringUtils.snakeCase)
      .reduce((abTestPermissions, permission) => {
        const newPermission = stringUtils.camelCase(
          `${permission}_type_${componentsOverride[permission].type}`
        );
        if (supportedABTestPermissions.includes(newPermission)) {
          abTestPermissions[permission] = newPermission;
          return abTestPermissions;
        }
        return abTestPermissions;
      }, {})
  );
};

const fn = (componentsOverride, permissions) => {
  const abTestPermissions = getPermissionsOverride(componentsOverride);
  const permissionsToRemove = Object.keys(abTestPermissions);
  const permissionsToAdd = Object.keys(abTestPermissions).map(
    key => abTestPermissions[key]
  );
  return permissions
    .filter(permission => !permissionsToRemove.includes(permission))
    .concat(permissionsToAdd);
};

export default fn;
